import React, { useEffect, useState } from "react";
import { getSkillsListApi, updateSkillApi } from "../../../../services/skills";
import useFullPageLoader from "../../../../hooks/useFullPageLoader";
import findSerialNumber from "../../../../utils/findSerialNumber";
import { CapitalizeFirstWord } from "../../../../utils/CapitalizeFirstWord";
import { dateFormat } from "../../../../utils/dateFormat";
import NotFound from "../../../../components/not-found/NotFound";
import Pagination from "react-js-pagination";
import { useSearchParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddSkills from "./AddSkills";
import EditSkill from "./EditSkill";
import AddIcon from '@mui/icons-material/Add';
import ModalBox from "../../../../components/modal/ModalBox";
import Switch from "../../../../components/Switch/Switch";
import { toastMessage } from "../../../../utils/toastMessage";
import useButtonLoader from "../../../../hooks/UseButtonLoader";


const Skills = ({
  userType,
  type,
  title,
  contentData,
  setContentData,
  total,
  setTotal,
  activePage,
  setSearchParam,
  searchParam,
}) => {
  const [buttonRef,buttonLoader]=useButtonLoader("Yes")
  const [skillId,setSkillId]=useState({});
  const [statusModal,setStatusModal]=useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const getCmsDetails = async () => {
    try {
      showLoader();
      const page = activePage - 1; // Backend uses 0-based pagination
      const { data } = await getSkillsListApi({ 
        page, 
        pageSize: 10,
        userType,
        status: undefined // Get all skills, filter by status if needed
      });
      if (data?.success) {
        setContentData(data?.data?.list || []);
        setTotal(data?.data?.pagination?.totalDocuments || 0);
      } else {
        setContentData([]);
        setTotal(0);
      }
    } catch (error) {
      console.log("error", error);
      setContentData([]);
      setTotal(0);
    } finally {
      hideLoader();
    }
  };

    // Change Skill Status Handler
    const changeSkillStatusHandler = async () => {
      try {
        buttonLoader(true);
        const res = await updateSkillApi(skillId.skillId, {
          status: !skillId.status
        });
        if (res?.data?.success) {
          toastMessage(res?.data?.message || "Status updated successfully", "success", "languageStatus");
          setStatusModal(false);
          setSkillId({});
          getCmsDetails();
        } else {
          toastMessage(res?.data?.message || "Failed to update status", "error", "languageStatus");
          setSkillId({});
        }
      } catch (e) {
        console.log(e.message);
        toastMessage("Error updating status", "error", "languageStatus");
      } finally {
        buttonLoader(false);
      }
    };

  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  const editHandler = (data) => {
    setSelectedSkill(data);
    setEditModal(true);
  };

  useEffect(() => {
    getCmsDetails();
    // Temporarily run only once on mount to prevent infinite rerenders
  }, []);
  return (
    <>
      <div className="TitleBox mt-4">
        <h4 className="Title">Skills</h4>
        <div className="block_user_button">
          <button onClick={() => setAddModal(true)}><AddIcon/>Add Skills</button>
        </div>
      </div>
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>Skills</th>
              <th>Image</th>
              <th>Banner Image</th>
              <th className="text-center"> Action </th>
            </tr>
          </thead>
          <tbody>
            {contentData.length > 0 ? (
              contentData.map((user, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td>{findSerialNumber(index, activePage, 10)}</td>
                      <td>{user?.title}</td>
                    
                      <td className="user_profile_image">
                        <img
                          src={user.skillImage || user?.skillImage}
                          alt={`${user?.title} profile image`}
                        />
                      </td>
                      <td className="user_profile_image">
                        {user.skillBannerImage || user?.skillBannerImage ? (
                          <img
                            src={user.skillBannerImage || user?.skillBannerImage}
                            alt={`${user?.title} banner image`}
                            style={{ maxWidth: "150px", maxHeight: "80px" }}
                          />
                        ) : (
                          <span style={{ color: "#999" }}>No banner</span>
                        )}
                      </td>
                      <td>
                        <div className="action_button">
                        <Switch
                            checked={user.status}
                            onChange={async () => {
                              await updateSkillApi(user._id, {status: !user.status});
                              getCmsDetails();
                            }}
                          />
                          <IconButton
                            aria-label="update"
                            className="px-2 py-0"
                            onClick={() => editHandler(user)}
                          >
                            <EditIcon className="edit_icon" />
                          </IconButton>
                        
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })
            ) : (
              <NotFound
                cols={10}
                msg="Skills not found!"
                // icon={NOT_FOUND}
                loader={loader}
              />
            )}
          </tbody>
        </table>
      </div>
      {total > 10 ? (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={10}
              totalItemsCount={total}
              pageRangeDisplayed={10}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      ) : null}

      <AddSkills
        setAddModal={setAddModal}
        addModal={addModal}
        getCmsDetails={getCmsDetails}
        userType={userType}
        type={type}
      />
      <EditSkill
        setEditModal={setEditModal}
        editModal={editModal}
        selectedSkill={selectedSkill}
        setSelectedSkill={setSelectedSkill}
        getCmsDetails={getCmsDetails}
        type={type}
      />
            <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        title={"Change Status"}
        description={"Are you sure want to change status of this skill?"}
        action={changeSkillStatusHandler}
        buttonref={buttonRef}
      />
    </>
  );
};

export default Skills;
